import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Check } from 'lucide-react';
const BUYING = ['Contract and Section 32 review', 'Special-condition advice', 'Title and disclosure checks', 'Auction and private-sale matters', 'Settlement coordination'];
const SELLING = ['Contract of sale preparation', 'Section 32 vendor statement', 'Buyer enquiry management', 'Auction and private-sale matters', 'Settlement coordination'];
export function BuyerSellerSplit() {
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-background" data-id="element-180">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-181">
        {/* Buyer */}
        <article className="group rounded-4xl overflow-hidden bg-surface border border-border shadow-card flex flex-col" data-id="element-182">
          <div className="relative h-52 overflow-hidden" data-id="element-183">
            <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1000&q=80" alt="Contemporary Melbourne home interior with natural light" className="w-full h-full object-cover transition-transform duration-700 ease-soft group-hover:scale-105" loading="lazy" data-id="element-184" />
            <span className="absolute top-4 left-4 rounded-full bg-accent text-white px-3 py-1 text-xs font-semibold tracking-wide" data-id="element-185">
              For buyers
            </span>
          </div>
          <div className="p-8 md:p-10 flex flex-col flex-1" data-id="element-186">
            <h2 className="font-serif text-3xl text-ink mb-3" data-id="element-187">
              Buying property?
            </h2>
            <p className="text-muted-ink leading-relaxed mb-7" data-id="element-188">
              Get the contract reviewed, understand the conditions and know what
              needs attention before you commit a single dollar.
            </p>
            <ul className="space-y-3 mb-9" data-id="element-189">
              {BUYING.map(item => <li key={item} className="flex items-start gap-3" data-id="element-190">
                  <span className="mt-0.5 inline-flex w-5 h-5 items-center justify-center rounded-full bg-accent-soft text-accent shrink-0" data-id="element-191">
                    <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-192" />
                  </span>
                  <span className="text-ink" data-id="element-193">{item}</span>
                </li>)}
            </ul>
            <div className="mt-auto" data-id="element-194">
              <Link to="/buying-property" data-id="element-195">
                <Button variant="accent" className="w-full sm:w-auto" data-id="element-196">
                  Explore buyer services
                </Button>
              </Link>
            </div>
          </div>
        </article>

        {/* Seller */}
        <article className="group rounded-4xl overflow-hidden bg-ink text-cream border border-ink shadow-card flex flex-col" data-id="element-197">
          <div className="relative h-52 overflow-hidden" data-id="element-198">
            <img src="https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?auto=format&fit=crop&w=1000&q=80" alt="Victorian terrace facade in inner Melbourne" className="w-full h-full object-cover opacity-90 transition-transform duration-700 ease-soft group-hover:scale-105" loading="lazy" data-id="element-199" />
            <span className="absolute top-4 left-4 rounded-full bg-cream text-ink px-3 py-1 text-xs font-semibold tracking-wide" data-id="element-200">
              For sellers
            </span>
          </div>
          <div className="p-8 md:p-10 flex flex-col flex-1" data-id="element-201">
            <h2 className="font-serif text-3xl text-cream mb-3" data-id="element-202">
              Selling property?
            </h2>
            <p className="text-cream/75 leading-relaxed mb-7" data-id="element-203">
              Prepare the contract and vendor statement correctly, respond to
              buyer enquiries and keep the transaction moving toward settlement.
            </p>
            <ul className="space-y-3 mb-9" data-id="element-204">
              {SELLING.map(item => <li key={item} className="flex items-start gap-3" data-id="element-205">
                  <span className="mt-0.5 inline-flex w-5 h-5 items-center justify-center rounded-full bg-accent text-white shrink-0" data-id="element-206">
                    <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-207" />
                  </span>
                  <span className="text-cream/90" data-id="element-208">{item}</span>
                </li>)}
            </ul>
            <div className="mt-auto" data-id="element-209">
              <Link to="/selling-property" data-id="element-210">
                <Button variant="accent" className="w-full sm:w-auto" data-id="element-211">
                  Explore seller services
                </Button>
              </Link>
            </div>
          </div>
        </article>
      </div>
    </section>;
}